import { defineStore } from 'pinia';

type ScrollLockStoreState = {
  _elementNamesCurrentlyPreventingScroll: string[];
  pageShouldBeScrollLocked: boolean;
};

const initialState: ScrollLockStoreState = {
  _elementNamesCurrentlyPreventingScroll: [],
  pageShouldBeScrollLocked: false,
};

export const useMyScrollLockStore = defineStore('myScrollLockStore', {
  state: (): ScrollLockStoreState => initialState,
  actions: {
    addPageScrollLockForElement(elementName: string) {
      this._elementNamesCurrentlyPreventingScroll.push(elementName);
      this.pageShouldBeScrollLocked = true;
    },
    removePageScrollLockForElement(elementName: string) {
      if (!this._elementNamesCurrentlyPreventingScroll.includes(elementName)) {
        return;
      }

      const newElementNamesThatPreventScroll =
        this._elementNamesCurrentlyPreventingScroll.filter(
          (name) => name !== elementName,
        );

      this._elementNamesCurrentlyPreventingScroll =
        newElementNamesThatPreventScroll;

      if (this._elementNamesCurrentlyPreventingScroll.length === 0) {
        this.pageShouldBeScrollLocked = false;
      }
    },
  },
});
